import React from 'react';
import styled from '@emotion/styled';
import { Colors, Space, Breakpoints } from './Styles';
import { Link } from 'gatsby';
import { getS3ImageUrl } from '../common/format';

const SinglePostDiv = styled.div`
  border: 1px solid ${Colors.neutrals[200]};
  margin: ${props => (props.isAllPosts ? Space[18] : Space[8])};
  padding: ${props => (props.isAllPosts ? Space[48] : Space[32])};
  display: flex;
  justify-content: center;
  flex-direction: column;
  // Medium tailwind box-shadow
  // https://github.com/tailwindlabs/tailwindcss/blob/master/stubs/defaultConfig.stub.js
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-height: 18rem;
  flex: 1;
  max-width: ${props => (props.isRelatedPost ? '30rem' : 'none')};

  a {
    color: ${Colors.primary[500]};

    :hover {
      color: ${Colors.primary[600]};
    }
  }

  @media (max-width: ${Breakpoints.sm}) {
    padding: ${Space[20]};
    margin: ${Space[12]};
  }
`;

const PostDateParagraph = styled.p`
  text-align: right;
  padding-bottom: ${Space[24]};
  color: ${Colors.neutrals[500]};
  font-size: ${Space[12]};

  @media (max-width: ${Breakpoints.lg}) {
    text-align: left;
  }
`;

const KeepReadingSpan = styled.span`
  font-size: ${Space[12]};
  border-radius: ${Space[8]};
  padding: ${Space[18]} 0;
  padding-right: ${Space[12]};
`;

const PostTitleSpan = styled.span`
  font-size: ${Space[24]};

  @media (max-width: ${Breakpoints.lg}) {
    font-size: ${Space[16]};
  }
`;

const PostExcerptDiv = styled.div`
  margin-bottom: ${Space[24]};

  @media (max-width: ${Breakpoints.lg}) {
    font-size: ${Space[14]};
  }
`;

const ExcerptDiv = styled.div`
  padding: ${Space[16]} 0;
`;

const SinglePost = ({
  id,
  date,
  slug,
  title,
  excerpt,
  isMainPost,
  isRelatedPost,
  isAllPosts,
}) => {
  return (
    <SinglePostDiv
      key={id}
      isRelatedPost={isRelatedPost}
      isAllPosts={isAllPosts}
    >
      <PostDateParagraph>{date}</PostDateParagraph>
      {isMainPost && (
        <div style={{ padding: `${Space[12]} 0` }}>
          <img src={getS3ImageUrl('blog-post-cover.png')} />
        </div>
      )}
      <Link to={`/${slug}`}>
        <PostTitleSpan
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Link>
      <ExcerptDiv>
        <PostExcerptDiv
          dangerouslySetInnerHTML={{
            __html: excerpt.replace(/<a class="more-link.*/, ''),
          }}
        />

        <Link to={`/${slug}`}>
          <KeepReadingSpan>Read more →</KeepReadingSpan>
        </Link>
      </ExcerptDiv>
    </SinglePostDiv>
  );
};

export default SinglePost;
